/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { useRequest } from '../../hooks/UseRequest'
import Loading from '../../components/Loading'
import DashletSuccessIcon from '../../components/elements/DashletSuccessIcon'
import DashletDeclineIcon from '../../components/elements/DashletDeclineIcon'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectModules } from '../../redux/moduleSlice'
import DashletTooltip from '../../components/elements/DashletTooltip'
import NoRecord from '../../components/elements/NoRecord'

export default function LoanAgreementDashlet({ endpointPath, dropdownOptions }) {
  const requests = useRequest()
  const requesting = useRef(false)
  const [row, setRow] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [loanAgreementModule, setLoanAgreementModule] = useState()
  const [programModule, setProgramModule] = useState()
  const modules = useSelector(selectModules)

  useEffect(() => {
    const getRow = async () => {
      requests.setEndpoint(endpointPath)
      try {
        const response = await requests.get()
        setRow(response.data.data)
        const lam = modules.data.find((e) => e.code_key === 'loan_agreement')
        setLoanAgreementModule(lam)
        const pm = modules.data.find((e) => e.code_key === 'program')
        setProgramModule(pm)
        setLoaded(true)
      } catch (error) {
        setLoaded(true)
      }
    }
    if (!requesting.current && endpointPath && row.length === 0) {
      setLoaded(false)
      requesting.current = true
      getRow()
    }
  }, [endpointPath])

  const renderHeader = (column_name, customize_label = false) => {
    if (customize_label) {
      return column_name
    }

    let data = loanAgreementModule.module_fields.find(
      (header) => header.column_name === column_name
    )

    if (!data) {
      data = programModule.module_fields.find(
        (header) => header.column_name === column_name
      )
    }

    if (data && !data.helper_text) {
      return data?.label_name
    }
    return <DashletTooltip columnName={data?.label_name} tooltipText={data?.helper_text} />
  }

  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Loan Agreement Detail</p>
      </div>
      <div className="message-body py-0 px-1" style={{ lineHeight: 1.40 }}>
        {loaded && row && row.id && (
          <>
            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader("id")}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-link is-size-8">
                <Link
                  key={`loan-dashlet-view-${row.id}`}
                  to={`/program/${row.id}`}
                  className="lox-has-text-decoration-none"
                >
                  {row.id}
                </Link>
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>
            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('Name', true)}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.name || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('is_active')}
              </p>
              <p className="lox-dashlet-detail__item__data is-size-8 px-0 lox-dashlet-detail__icon">
                {row.is_active == 0 ? (
                  <DashletDeclineIcon />
                ) : (
                  <DashletSuccessIcon />
                )}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('Portfolio', true)}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.portfolio_label || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('number_of_installments')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {row.number_of_installments || '-'}
              </p>
            </div>
            <div className="divider m-0 mx-1"></div>

            <div className="lox-dashlet-detail__item py-0 px-1">
              <p className="lox-dashlet-detail__item__label has-text-grey is-size-8">
                {renderHeader('pay_frequency_dropdown_option_id')}
              </p>
              <p className="lox-dashlet-detail__item__data has-text-dark is-size-8">
                {dropdownOptions[row.pay_frequency_dropdown_option_id]?.name || '-'}
              </p>
            </div>
          </>
        )}
        {!loaded && <Loading />}
        {loaded && row.length === 0 && <NoRecord />}
      </div>
    </div>
  )
}
